export { default } from "./StudentWriteResponseForm";
